import { render, staticRenderFns } from "./GalleryPopup.vue?vue&type=template&id=7b6a6890&"
import script from "./GalleryPopup.vue?vue&type=script&lang=js&"
export * from "./GalleryPopup.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports